import { computed, type ComputedRef } from 'vue';

import type { Capability } from '@/auth/capabilities';
import type { PolicyContext } from '@/auth/Policy';
import { authSession } from '@/auth/useAuth';
import { usePartnerContext } from '@/partner/usePartnerContext';
import { useFeatureFlagsStore } from '@/stores/featureFlagsStore';

export function usePolicyContext(): ComputedRef<PolicyContext> {
  const partner = usePartnerContext();
  const featureFlagsStore = useFeatureFlagsStore();

  return computed(() => ({
    can: (capability: Capability) => authSession.value.canAccess(capability),
    profiles: authSession.value.profiles,
    partner: partner.value,
    features: featureFlagsStore.flags,
  }));
}
